import type { FC } from 'react';
const CommentListLoading: FC = () => {
  // TODO implement later skeleton
  return 'loading';
};
export default CommentListLoading;